import { widgetState } from '../../store/customizations/index'
import { merchantState } from '../../store/merchant/index'
import { getProduct } from '../../store/product/getters'
import { getSelectedSellingPlanGroup, getSelectedSellingPlanId, getSellingPlanGroups } from '../../store/selling-plans/getters'
import { getFormElement } from '../injection/injection'
import { DurationStats, PixelEvent } from './types'
import { YotpoAnalytics } from './yotpo-analytics'

export const dispatchEvent = (event: PixelEvent): void => {
  if (!shouldSendAnalytics()) {
    return
  }
  const productPageEvent = {
    ...event,
    category: 'product-page-widget'
  }
  YotpoAnalytics.track(merchantState.guid, productPageEvent)
}

export const getLoadedEvent = (instanceId: number, instanceVersionId: number): PixelEvent => {
  return {
    action: 'loaded',
    context: {
      widget_instance_id: instanceId,
      instance_version_id: instanceVersionId,
      ...getDurationStats()
    }
  }
}

export const dispatchLoadedEvent = (loadedEvent: PixelEvent): void => {
  loadedEvent.context = {
    ...loadedEvent.context,
    should_be_shown: widgetState.customizations.isLaunched && getSellingPlanGroups().length > 0,
    is_launched: widgetState.customizations.isLaunched,
    live_preview: widgetState.customizations.livePreview.show
  }
  dispatchEvent(loadedEvent)
}

const shouldSendAnalytics = () => {
  return !(widgetState.customizations.isReadOnly || widgetState.customizations.isPreview)
}

export const initAddToCartAnalytics = (): void => {
  const addToCartForm = getFormElement()
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', () => {
      try {
        addToCartSuccess()
      } catch (error) {
        console.error(error)
      }
    })
  } else {
    dispatchEvent({
      action: 'error',
      label: 'add_to_cart',
      context: {
        error_msg: 'missing add to cart form'
      }
    })
  }
}

const addToCartSuccess = (): void => {
  const selectedSellingPlanGroup = getSelectedSellingPlanGroup()
  if (selectedSellingPlanGroup && selectedSellingPlanGroup.id !== 'buy-once') {
    dispatchEvent({
      action: 'clicked_on',
      label: 'add_to_cart',
      context: {
        product_id: getProduct().id.toString(),
        selling_plan_id: getSelectedSellingPlanId(),
        selected_group_id: selectedSellingPlanGroup.id,
        live_preview: widgetState.customizations.livePreview.show
      }
    })
  }
}

const getDurationStats = (): DurationStats|null => {
  if (typeof (window) !== 'undefined' && window.performance) {
    const widgetEnd = window.performance.now()
    const initStart = window.performance.getEntriesByName('yotpo:initializer:loaded')
    if (initStart.length > 0) {
      const durationFromInit = Math.round(widgetEnd - initStart[0].startTime)
      let durationFromDomLoadedEvent = 0
      if (window.performance.timing) {
        const domLoaded = (window.performance.timing.domContentLoadedEventStart - window.performance.timing.navigationStart)
        durationFromDomLoadedEvent = Math.round(widgetEnd - domLoaded)
      }
      return {
        time_from_init_start: durationFromInit,
        time_from_dom_loaded: durationFromDomLoadedEvent
      }
    }
  }
  return null
}
